export const VIEWED_STORAGE_KEY = "mgh_viewed_properties";
export const CONTACTED_STORAGE_KEY = "mgh_contacted_properties";

export const SAMPLE_VIEWED_PROPERTIES = [
  {
    _id: "viewed_sample_1",
    propertyID: "MGH-10492",
    apartment: "Aparna Serene Park",
    visiblePrice: "8.02 - 9.37 Cr",
    expectedPrice: "85000000",
    noofBedrooms: 4,
    noofBathrooms: 4,
    carpetArea: 3850,
    locality: "Kondapur",
    city: "Hyderabad",
    state: "Telangana",
    superCategory: "Residential",
    subCategory: "Apartment",
    category: "Sell",
    furnishing: "Semi-Furnished",
    propertyFacing: "East",
    propertyOnFloor: "14",
    noofFloor: "24",
    postUserName: "Aparna Constructions",
    postUserMobile: "9160213545",
    postUserPosition: "Builder",
    DeskImg: ["/assets/images/hero_banner_new.png"],
    viewedAt: "2 hours ago",
  },
  {
    _id: "viewed_sample_2",
    propertyID: "MGH-17538",
    apartment: "Autuman villas",
    visiblePrice: "2.15 Cr",
    expectedPrice: "21500000",
    noofBedrooms: 3,
    noofBathrooms: 3,
    carpetArea: 2450,
    locality: "Thukkuguda",
    city: "Hyderabad",
    state: "Telangana",
    superCategory: "Residential",
    subCategory: "Villa",
    category: "Sell",
    furnishing: "Furnished",
    propertyFacing: "North-East",
    propertyOnFloor: "G+1",
    noofFloor: "2",
    postUserName: "V laxman",
    postUserMobile: "9160213545",
    postUserPosition: "Owner",
    DeskImg: ["/assets/images/why_choose_villa.jpg"],
    viewedAt: "Yesterday",
  },
  {
    _id: "viewed_sample_3",
    propertyID: "MGH-18921",
    apartment: "Prestige High Fields",
    visiblePrice: "1.80 Cr",
    expectedPrice: "18000000",
    noofBedrooms: 3,
    noofBathrooms: 3,
    carpetArea: 1980,
    locality: "Gachibowli",
    city: "Hyderabad",
    state: "Telangana",
    superCategory: "Residential",
    subCategory: "Apartment",
    category: "Sell",
    furnishing: "Unfurnished",
    propertyFacing: "East",
    propertyOnFloor: "8",
    noofFloor: "32",
    postUserName: "Rajesh Kumar",
    postUserMobile: "9160213545",
    postUserPosition: "Agent",
    DeskImg: ["/assets/images/hero_slide_2.jpg"],
    viewedAt: "3 days ago",
  },
  {
    _id: "viewed_sample_4",
    propertyID: "MGH-19204",
    apartment: "My Home Bhooja",
    visiblePrice: "3.20 Cr",
    expectedPrice: "32000000",
    noofBedrooms: 3,
    noofBathrooms: 3,
    carpetArea: 2600,
    locality: "HITEC City",
    city: "Hyderabad",
    state: "Telangana",
    superCategory: "Residential",
    subCategory: "Apartment",
    category: "Sell",
    furnishing: "Semi-Furnished",
    propertyFacing: "North",
    propertyOnFloor: "19",
    noofFloor: "36",
    postUserName: "My Home Group",
    postUserMobile: "9160213545",
    postUserPosition: "Builder",
    DeskImg: ["/assets/images/hero_slide_3.jpg"],
    viewedAt: "4 days ago",
  },
  {
    _id: "viewed_sample_5",
    propertyID: "MGH-21045",
    apartment: "Vessella Woods",
    visiblePrice: "4.50 Cr",
    expectedPrice: "45000000",
    noofBedrooms: 4,
    noofBathrooms: 4,
    carpetArea: 3950,
    locality: "Kondapur",
    city: "Hyderabad",
    state: "Telangana",
    superCategory: "Residential",
    subCategory: "Villa",
    category: "Sell",
    furnishing: "Furnished",
    propertyFacing: "East",
    propertyOnFloor: "Duplex",
    noofFloor: "2",
    postUserName: "Srinivas Rao",
    postUserMobile: "9160213545",
    postUserPosition: "Owner",
    DeskImg: ["/assets/images/villa_header_banner.jpg"],
    viewedAt: "5 days ago",
  },
  {
    _id: "viewed_sample_6",
    propertyID: "MGH-23910",
    apartment: "Cybercity Rainbow Vistas",
    visiblePrice: "65,000 / mo",
    expectedPrice: "65000",
    noofBedrooms: 3,
    noofBathrooms: 3,
    carpetArea: 1850,
    locality: "Moosapet",
    city: "Hyderabad",
    state: "Telangana",
    superCategory: "Residential",
    subCategory: "Apartment",
    category: "Rent",
    furnishing: "Semi-Furnished",
    propertyFacing: "West",
    propertyOnFloor: "11",
    noofFloor: "19",
    postUserName: "Ramesh Verma",
    postUserMobile: "9160213545",
    postUserPosition: "Dealer",
    DeskImg: ["/assets/images/hero_slide_4.jpg"],
    viewedAt: "1 week ago",
  },
];

export const SAMPLE_CONTACTED_PROPERTIES = [
  {
    _id: "contact_sample_1",
    propertyID: "MGH-10492",
    apartment: "Aparna Serene Park",
    visiblePrice: "8.02 - 9.37 Cr",
    expectedPrice: "85000000",
    noofBedrooms: 4,
    noofBathrooms: 4,
    carpetArea: 3850,
    locality: "Kondapur",
    city: "Hyderabad",
    state: "Telangana",
    superCategory: "Residential",
    subCategory: "Apartment",
    category: "Sell",
    furnishing: "Semi-Furnished",
    propertyFacing: "East",
    postUserName: "Aparna Constructions",
    postUserMobile: "9160213545",
    postUserPosition: "Builder",
    DeskImg: ["/assets/images/hero_banner_new.png"],
    contactedAt: "Today, 11:30 AM",
    contactStatus: "Phone Unlocked",
    contactType: "phone",
  },
  {
    _id: "contact_sample_2",
    propertyID: "MGH-17538",
    apartment: "Autuman villas",
    visiblePrice: "2.15 Cr",
    expectedPrice: "21500000",
    noofBedrooms: 3,
    noofBathrooms: 3,
    carpetArea: 2450,
    locality: "Thukkuguda",
    city: "Hyderabad",
    state: "Telangana",
    superCategory: "Residential",
    subCategory: "Villa",
    category: "Sell",
    furnishing: "Furnished",
    propertyFacing: "North-East",
    postUserName: "V laxman",
    postUserMobile: "9160213545",
    postUserPosition: "Owner",
    DeskImg: ["/assets/images/why_choose_villa.jpg"],
    contactedAt: "Yesterday",
    contactStatus: "Enquiry Sent",
    contactType: "contact",
  },
  {
    _id: "contact_sample_3",
    propertyID: "MGH-19204",
    apartment: "My Home Bhooja",
    visiblePrice: "3.20 Cr",
    expectedPrice: "32000000",
    noofBedrooms: 3,
    noofBathrooms: 3,
    carpetArea: 2600,
    locality: "HITEC City",
    city: "Hyderabad",
    state: "Telangana",
    superCategory: "Residential",
    subCategory: "Apartment",
    category: "Sell",
    furnishing: "Semi-Furnished",
    propertyFacing: "North",
    postUserName: "My Home Group",
    postUserMobile: "9160213545",
    postUserPosition: "Builder",
    DeskImg: ["/assets/images/hero_slide_3.jpg"],
    contactedAt: "3 days ago",
    contactStatus: "Callback Requested",
    contactType: "phone",
  },
];

// ----------------- VIEWED UTILS -----------------
export const getViewedProperties = () => {
  try {
    const raw = localStorage.getItem(VIEWED_STORAGE_KEY);
    if (!raw) return SAMPLE_VIEWED_PROPERTIES;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : SAMPLE_VIEWED_PROPERTIES;
  } catch (err) {
    return SAMPLE_VIEWED_PROPERTIES;
  }
};

export const addViewedProperty = (property) => {
  if (!property) return;
  try {
    const list = getViewedProperties().filter(
      (item) => String(item._id || item.propertyID) !== String(property._id || property.propertyID)
    );
    const updated = [
      {
        ...property,
        viewedAt: "Just now",
      },
      ...list,
    ];
    localStorage.setItem(VIEWED_STORAGE_KEY, JSON.stringify(updated.slice(0, 30)));
  } catch (e) {
    // Ignore storage errors
  }
};

export const removeViewedProperty = (id) => {
  try {
    const list = getViewedProperties();
    const updated = list.filter(
      (item) => String(item._id) !== String(id) && String(item.propertyID) !== String(id)
    );
    localStorage.setItem(VIEWED_STORAGE_KEY, JSON.stringify(updated));
    return updated;
  } catch (e) {
    return [];
  }
};

export const clearViewedProperties = () => {
  try {
    localStorage.setItem(VIEWED_STORAGE_KEY, JSON.stringify([]));
  } catch (e) {
    // Ignore
  }
};

export const getViewedCount = () => {
  return getViewedProperties().length;
};

// ----------------- CONTACTED UTILS -----------------
export const getContactedProperties = () => {
  try {
    const raw = localStorage.getItem(CONTACTED_STORAGE_KEY);
    if (!raw) return SAMPLE_CONTACTED_PROPERTIES;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : SAMPLE_CONTACTED_PROPERTIES;
  } catch (err) {
    return SAMPLE_CONTACTED_PROPERTIES;
  }
};

export const addContactedProperty = (property, type = "contact") => {
  if (!property) return;
  try {
    const list = getContactedProperties().filter(
      (item) => String(item._id || item.propertyID) !== String(property._id || property.propertyID)
    );
    const updated = [
      {
        ...property,
        contactedAt: "Just now",
        contactStatus: type === "phone" ? "Phone Unlocked" : "Enquiry Sent",
        contactType: type,
      },
      ...list,
    ];
    localStorage.setItem(CONTACTED_STORAGE_KEY, JSON.stringify(updated.slice(0, 30)));
  } catch (e) {
    // Ignore
  }
};

export const removeContactedProperty = (id) => {
  try {
    const list = getContactedProperties();
    const updated = list.filter(
      (item) => String(item._id) !== String(id) && String(item.propertyID) !== String(id)
    );
    localStorage.setItem(CONTACTED_STORAGE_KEY, JSON.stringify(updated));
    return updated;
  } catch (e) {
    return [];
  }
};

export const clearContactedProperties = () => {
  try {
    localStorage.setItem(CONTACTED_STORAGE_KEY, JSON.stringify([]));
  } catch (e) {
    // Ignore
  }
};

export const getContactedCount = () => {
  return getContactedProperties().length;
};
